/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaModuloVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaModulo: React.FunctionComponent<ITablaModuloVistaProps & InjectedIntlProps> = ({
    modulos,
    cargarModulo,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={modulos}
            actions={acciones(manejarFormulario, cargarModulo, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaModulo);
